import { render, staticRenderFns } from "./PropertyDetails.vue?vue&type=template&id=bd21381c&scoped=true&"
import script from "./PropertyDetails.vue?vue&type=script&lang=js&"
export * from "./PropertyDetails.vue?vue&type=script&lang=js&"
import style0 from "./PropertyDetails.vue?vue&type=style&index=0&id=bd21381c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd21381c",
  null
  
)

export default component.exports